/**
 * Endpoints des référentiels du "CV par thème de formation" (gestion admin).
 *
 * Les 4 référentiels exposent le même CRUD REST : une fabrique évite de répéter
 * le quintuplet list/detail/create/update/delete pour chaque ressource.
 */

const createReferentielEndpoints = (path) => ({
  list: () => `/api/${path}`,
  detail: (id) => `/api/${path}/${id}`,
  create: () => `/api/${path}`,
  update: (id) => `/api/${path}/${id}`,
  // `force` passe outre le garde-fou qui signale les déclarations de formateurs.
  // L'écran ne l'emploie qu'après avoir montré la conséquence et obtenu une
  // seconde confirmation.
  delete: (id, { force = false } = {}) => `/api/${path}/${id}${force ? '?force=true' : ''}`,
})

// Compétences : enfants directs d'une catégorie de formations depuis la fusion
// des référentiels. Le matériel suit le même CRUD, son rattachement aux
// catégories passant par les endpoints de `formationsEndpoints.categories`.
export const competencesEndpoints = createReferentielEndpoints('competences')
export const materielsEndpoints = createReferentielEndpoints('materiels')
export const approchesPedagogiquesEndpoints = createReferentielEndpoints('approches-pedagogiques')
export const certificationsEndpoints = createReferentielEndpoints('certifications')
export const publicsFormesEndpoints = createReferentielEndpoints('publics-formes')

// Lecture publique (formulaire d'inscription formateur) : catégories, compétences et matériel.
export const competencesReferentielEndpoints = {
  public: () => `/api/public/competences-referentiel`,
}
